import React from 'react'
import {Stack, TextField, Typography, SxProps, Theme} from '@mui/material'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface TextAreaNewProps {
  value: string
  onChange: (value: string) => void
  label?: string
  placeholder?: string
  rows?: number
  required?: boolean
  disabled?: boolean
  error?: boolean
  helperText?: string
  fullWidth?: boolean
  sx?: SxProps<Theme>
}

export default function TextAreaNew({
  value,
  onChange,
  label,
  placeholder,
  rows = 3,
  required,
  disabled,
  error,
  helperText,
  fullWidth,
  sx,
}: TextAreaNewProps): JSX.Element {
  return (
    <Stack spacing={0.5} sx={{width: fullWidth ? '100%' : undefined, ...sx}}>
      {label && (
        <Typography variant="caption" sx={{fontWeight: 600, color: NEUTRAL_SCALE[700], textTransform: 'uppercase', letterSpacing: '0.05em'}}>
          {label}{required && ' *'}
        </Typography>
      )}
      <TextField
        multiline
        rows={rows}
        size="small"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        fullWidth={fullWidth}
        required={required}
        disabled={disabled}
        error={error}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#fff',
            '& fieldset': {borderColor: error ? 'error.main' : NEUTRAL_SCALE[200]},
            '&:hover fieldset': {borderColor: error ? 'error.main' : NEUTRAL_SCALE[300]},
            '&.Mui-focused fieldset': {borderColor: error ? 'error.main' : 'primary.main'},
          },
          '& .MuiOutlinedInput-root.Mui-disabled': {backgroundColor: NEUTRAL_SCALE[100]},
          '& .MuiInputBase-input.Mui-disabled': {WebkitTextFillColor: NEUTRAL_SCALE[700]},
        }}
      />
      {helperText && (
        <Typography variant="caption" sx={{color: error ? 'error.main' : NEUTRAL_SCALE[500]}}>
          {helperText}
        </Typography>
      )}
    </Stack>
  )
}
